import React from 'react'
import { GoogleMap, LoadScript } from '@react-google-maps/api'
import { ModalWrapper } from 'components/Modals'

const GoogleMapModal = ({ onConfirm, onClose, addressType }) => {
  const mapContainerStyle = {
    width: '100%',
    height: '100%',
  }

  const center = {
    lat: 40.7128, // default latitude
    lng: -74.006, // default longitude
  }
  const onMapClick = (event) => {
    getAddressFromCoordinates(event.latLng.lat(), event.latLng.lng()).then((data) => {
      if (!data) return
      let address = null
      switch (addressType) {
        case 'city': {
          address = data.address?.city
          break
        }
        case 'state': {
          address = data.address?.state
          break
        }
        case 'country': {
          address = data.address?.country
          break
        }
        default:
          address = data.display_name
      }
      onConfirm(address)
    })
  }

  const getAddressFromCoordinates = async (lat, lng) => {
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`)
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error fetching address:', error)
    }
  }
  return (
    <ModalWrapper onClose={onClose} classNames="items-center !w-[90%] !h-[600px] !p-8">
      <LoadScript googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}>
        <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={12} onClick={onMapClick} />
      </LoadScript>
    </ModalWrapper>
  )
}

export default GoogleMapModal
